<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="flex flex-row" [class.invalid]="!isValid">
  <ng-select
    [items]="countries"
    [clearable]="false"
    [virtualScroll]="true"
    [readonly]="readonly"
    [(ngModel)]="countryCode"
    (change)="changeCountry($event)"
    bindLabel="name"
    bindValue="countryCode"
  >
    <ng-template ng-label-tmp let-item="item">
      <div class="code flex flex-row aic" *ngIf="item.countryCode && item.dialCode">
        <span [ngClass]="'flag flag-' + item.countryCode" class="mr5"></span>
        +{{ item.dialCode }}
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item">
      <span [ngClass]="'flag flag-' + item.countryCode" class="mr5"></span>
      {{ item.name }}
      <span class="code">+{{ item.dialCode }}</span>
    </ng-template>
  </ng-select>
  <input
    class="flex ml10"
    type="text"
    [imask]="{ mask: mask }"
    [unmask]="true"
    [placeholder]="placeholder"
    [readonly]="readonly"
    [(ngModel)]="tel"
    (ngModelChange)="telChange()"
    (blur)="onBlur()"
  />
  <div class="flex flex-row flex-nosize">
    <label>
      <rx-icon class="dark reset mr10" name="close" (click)="onReset()" *ngIf="phone"></rx-icon>
    </label>
  </div>
</div>
